import getDatasourceByType from './utils/getDatasourceByType';
import filters from '../filters';
import convertList from '../convertList';
import kfext from '../kfext';

function getCloudPhoneBook(userId) {
    return Vue.prototype.$_sAjax.get('/cc/callContacts/GetGroupList', {
        params: { selectKfext: userId || kfext.getCurrentId() }
    });
}

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    if (selfConfig.ajax) {
        // ajax 模式，目的是为了兼容在账户中心中使用
        return new Promise((resolve, reject) => {
            const moreConfig = {
                totalState: false
            };
            getCloudPhoneBook(selfConfig.userId) // 支持在配置中自定义id，用于接口请求的时候调用
                .then(res => {
                    let { list } = res.data;
                    list = list.map(x => {
                        const obj = x;
                        if (obj.total > 0) {
                            obj.list = [];
                        }
                        obj.pageIndex = 0;
                        obj.type = 'group';
                        obj.id = obj.groupId;
                        return obj;
                    });
                    const mergeConfig = Object.assign(config, moreConfig);
                    const newList = convertList(list, {}, mergeConfig);
                    return filters.setKfuinTypeInList(newList);
                })
                .then(list => {
                    resolve(list);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }
    // jssdk模式，从客户端获取数据
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'CloudPhoneBook',
            maps: {
                groupName: 'name'
            },
            moreConfig: config
        })
            .then(list => {
                return filters.setKfuinTypeInList(list);
            })
            .then(list => {
                resolve(list);
            })
            .catch(err => {
                reject(err);
            });
    });
}
